module.exports = __webpack_public_path__ + "img/齿轮油泵.SLDASM.97c0cc64.jpg";